import { render, staticRenderFns } from "./NewPerfildeUsuario.vue?vue&type=template&id=c19dc6e8&scoped=true&"
import script from "./NewPerfildeUsuario.vue?vue&type=script&lang=ts&"
export * from "./NewPerfildeUsuario.vue?vue&type=script&lang=ts&"
import style0 from "./NewPerfildeUsuario.vue?vue&type=style&index=0&id=c19dc6e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19dc6e8",
  null
  
)

export default component.exports